var map = {
	"./part2/voice/bridge_reference1.mp3": "4a95",
	"./part2/voice/bridge_reference2.mp3": "254d",
	"./part2/voice/reference1.mp3": "d205",
	"./part2/voice/reference2.mp3": "790f",
	"./part3/voice/bridge_reference1.mp3": "77f6",
	"./part3/voice/reference1.mp3": "c23f",
	"./part3/voice/reference2.mp3": "0fb9",
	"./part3/voice/reference3.mp3": "869f",
	"./part4/voice/bridge_reference1.mp3": "5122",
	"./part4/voice/reference1.mp3": "0e4f",
	"./part4/voice/reference2.mp3": "8789",
	"./part4/voice/reference3.mp3": "ee26",
	"./part5/voice/bridge_reference1.mp3": "8967",
	"./part5/voice/reference1.mp3": "4bb2",
	"./part6/voice/bridge_reference1.mp3": "4383"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06cb";